<!-- 申请信息 -->
<template>
  <div class="application-main">
    <div>
      <div class="application-left">
        <zlr-menu :menuList="menuListB" v-if="plan=='PLANB'"></zlr-menu>
        <zlr-menu :menuList="menuList" v-else></zlr-menu>
      </div>
      <div class="application-right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import './application.less'
// mixins
import bgColor from '@/view/mixins/bg-color'
// components
import ZlrMenu from '_c/menu/menu'
import { getPackagesInfo } from '@/api/info'
export default {
  name: 'application-info-main',
  components: {
    ZlrMenu
  },
  mixins: [bgColor],
  data () {
    return {
      menuList: [
        {
          title: '教育背景',
          path: '/application/education'
        },
        {
          title: '考试分数',
          path: '/application/score'
        },
        {
          title: '个人经历',
          path: '/application/experience'
        },
        {
          title: '申请意向',
          path: '/application/intention'
        },
        {
          title: '项目信息',
          path: '/application/project'
        },
        {
          title: '研究方向',
          path: '/application/research-direction'
        },
        {
          title: '科研经历',
          path: '/application/research-exp'
        },
        {
          title: '实习经历',
          path: '/application/practice'
        },
        {
          title: '课外活动',
          path: '/application/extracurricular'
        },
        {
          title: '家庭信息',
          path: '/application/family'
        }
      ],
      menuListB: [
        {
          title: '教育背景',
          path: '/application/education'
        },
        {
          title: '上传信息搜集表',
          path: '/application/upload-info'
        }
      ],
      plan: undefined
    }
  },
  computed: {},
  created () {
    this.getPackagesInfo()
  },
  mounted () {},
  methods: {
    // 获取套餐信息
    getPackagesInfo () {
      getPackagesInfo().then(res => {
        this.plan = res.data.model && res.data.model.detail && res.data.model.detail.plan
        // if (this.plan === 'PLANB') {
        //   this.$router.push({ name: 'application-upload-info' })
        // } else {
        //   this.$router.push({ name: 'application-education' })
        // }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
